import { render, staticRenderFns } from "./patientAssessment.vue?vue&type=template&id=8c5e82ee&scoped=true"
import script from "./patientAssessment.vue?vue&type=script&lang=js"
export * from "./patientAssessment.vue?vue&type=script&lang=js"
import style0 from "./patientAssessment.vue?vue&type=style&index=0&id=8c5e82ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5e82ee",
  null
  
)

export default component.exports